import { axiosGet} from "./api.gateway";

export const fetchDashboardData = async () => {
  try {
    const response = await axiosGet('/dashboard');
    return response;
  } catch (error) {
    throw error;
  }
}